import managers from './managers'
import users from './users'
import offices from './offices'
import manCompanies from './man-companies'
import steps from './steps'
import cameras from './cameras'

export default {
  admin: {
    namespaced: true,
    modules: {
      managers,
      users,
      offices,
      manCompanies,
      steps,
      cameras
    }
  }
}
